export default __webpack_public_path__ + "static/SMM_Peakwork_Pressemeldung_1_1_en-37b4c12ffa19df8ca0fe9ff3a757fc1a.png";